import * as React from 'react';
import './App.css';
import settings from './settings.json';
import Box from '@mui/material/Box';
import Drawer from './Drawer.js';
import MenuAsList from './MenuAsList.js';
import HomeIcon from '@mui/icons-material/Home';
import Button from '@mui/material/Button';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import CloseIcon from '@mui/icons-material/Close';


function App() {
  const [currentSection, setCurrentSection] = React.useState('home');
  const [currentImage, setCurrentImage] = React.useState(false);
  const goHome = () => {
    setCurrentSection('home');
  }
  const closeImage = () => {
    setCurrentImage(false);
  }
  const getSection = (slug) => {
    return settings.sections.find(s => s.slug === slug );
  }
  //const itemData = settings.galleryItems.concat(settings.menuItems.map(k => ({ "img": k.imageUrl })).filter(k => (k.img !== undefined)));
  const itemData = settings.galleryItems;
  const thisSection = getSection(currentSection);
  return (
    <div className="App">
      {currentSection && currentSection !== 'home' && !currentImage && (
        <Button className="homeButton" component="label" onClick={() => setCurrentSection('home')}>Home <HomeIcon /></Button>) }
      {currentSection === 'home'&& !currentImage  && (
        <header className="App-header">
        <img src="/img2025/storefront.png" className="App-logo" alt="logo" />
          <h1>
            <img src="/img2025/logo-red.png" style={{"maxWidth":"30%"}}/>
          </h1>
        </header>
      )}
      {currentSection === 'home'&& !currentImage  && (
        <div><p style={{marginTop: "0px"}}>Urban House is a bar and restaurant treasured by the local community for it's convivial atmosphere, excellent food, and incredible hospitality. Don't hesitate to contact us for reservations on our second floor for private parties, or just stop in for an great meal or drinks.</p><p>See you soon!</p></div>
      )}
      {currentSection !== 'home' && !currentImage && (
        <header className="App-header">
          <h2>
            {thisSection.title}
          </h2>
      { thisSection && thisSection.slug !== 'gallery' && thisSection.slug !== 'home' && !currentImage && (
        <p>Click on a menu item for an image and more detail</p>
      )}
    {currentSection === 'gallery' && !currentImage && (
      <ImageList sx={{ maxWidth: 800}}>
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.img}?w=248&fit=crop&auto=format`}
              alt={item.description}
              loading="lazy"
              onClick={() => { setCurrentImage(item.img); console.log(item.img)}}
            />
          { (item.description || item.title) && !currentImage && (
            <ImageListItemBar
              title={item.title}
              subtitle={item.description}
              position="below"
            />
          )}
          </ImageListItem>
        ))}
      </ImageList>
    )}
        </header>
      )}
      { thisSection && thisSection.description && !currentImage && (
        <p>{thisSection.description}</p>
      )}
    {!currentImage && (<Drawer currentSection={currentSection} setCurrentSection={setCurrentSection} />)}
      {currentSection && !currentImage && (<MenuAsList section={thisSection} />)}
      { thisSection && thisSection.slug !== 'gallery' && thisSection.slug !== 'home' && (
        <p>Plus applicable taxes. All prices subject to change without notice. Please notify your server for any allergies to food ingredients.</p>
      )}
      {currentSection === 'home' && !currentImage && (
        <div>
          <h3>{settings.address}</h3>
          <h3>Hours</h3>
          {Object.keys(settings.hours).map(k => {
            return (<p>{k}: {settings.hours[k]}</p>);
          })}
          <h3><a style={{color:"red"}} href={"tel:"+settings.contactPhone}>Contact: {settings.contactPhone}</a></h3>
          <h3><a style={{color:"red"}} href={"mailto:"+settings.contactEmail}>Email: {settings.contactEmail}</a></h3>
          <b>Follow us on 
            <a style={{color:"white"}} href="https://www.facebook.com/p/Urban-House-100051408972190/"><FacebookIcon sx={{fontSize:"2em", verticalAlign:"middle"}} /></a>or 
            <a style={{color:"white"}} href="https://www.instagram.com/urbanhouseeastside/"><InstagramIcon sx={{fontSize:"2em", verticalAlign:"middle"}} /></a></b>
        </div>
      )}
        { currentImage && (
        <header className="App-header">

          <Box sx={{position: "fixed", backgroundColor: "#111111", width:"90%", maxHeight: "90%", top: 30}}>
            <span style={{position: "absolute", right: 20}}>
            <CloseIcon sx={{top: 0, right: 20}} onClick={()=> closeImage()} /><br />
            </span>
          <br />
            <img src={currentImage} style={{maxWidth: "100%", paddingTop:20}} />
          </Box>
          </header>
        )}

    </div>
  );
}

export default App;
